<template>
  <!-- 通用统计数据显示。只有一个名称和总数的显示，可以显示两组数据 -->
  <div class="count-1">
    <div class="worker-num">
      <yq-number :value="count" :length="length" class="yq-icon-count"/>
      <div>{{ name }}</div>
    </div>
    <div class="worker-num"><slot/></div>
  </div>
</template>

<script>

import YqNumber from "@/components/YqNumber.vue";

export default {
  props: {
    count: {default: 0},
    name: {default: "统计数据"},
    length: {default: 5}, // 显示多少位数
  },

  name: "EmployeeCollection",
  components: {
    YqNumber,
  },
  data() {
    return {
    };
  },
  created() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>

.count-1{
  height: 60px;
  display: flex;
  .worker-num{
    width: 50%;
    .yq-icon-count{
      font-size: 18px;
    }
  }
  .worker-num:nth-child(2){
    text-align: right;
  }
}
</style>